// Presentation hygiene for both saved and newly generated research.
function cleanResearchText(value) {
  return String(value ?? '')
    .replace(/<a\b[^>]*>([\s\S]*?)<\/a>/gi, (_, label) => /^(?:source|\d+|(?:www\.)?[\w.-]+\.[a-z]{2,})$/i.test(label.trim()) ? '' : label)
    .replace(/<[^>]*>/g, '')
    .replace(/\[([^\]]*)\]\(https?:\/\/[^\s]*?\)/gi, (_, label) => /^(?:sources?|\d+|(?:www\.)?[\w.-]+\.[a-z]{2,}(?:\/.*)?)$/i.test(label.trim()) ? '' : label)
    .replace(/https?:\/\/[^\s<>]+/gi, '')
    .replace(/\b(?:www\.)?(?:openai|chatgpt)\.com(?:\/[^\s]*)?/gi, '')
    .replace(/(?:according to|generated by|powered by|using)\s+(?:OpenAI|ChatGPT|GPT[\w.-]*)/gi, '')
    .replace(/\b(?:OpenAI|ChatGPT|GPT[-\s]?\d[\w.-]*)\b/gi, '')
    .replace(/cite[^]*/g, '')
    .replace(/\[\d+(?:[ ,–-]+\d+)*\]/g, '')
    .replace(/\(\s*\)|\[\s*\]/g, '')
    .replace(/[ \t]+/g, ' ')
    .replace(/ +([.,;:!?])/g, '$1')
    .trim();
}
function cleanResearchUrl(value) {
  try {
    const parsed = new URL(String(value || ''));
    if (!['http:', 'https:'].includes(parsed.protocol)) return '';
    for (const key of [...parsed.searchParams.keys()]) {
      if (/^utm_/i.test(key)) parsed.searchParams.delete(key);
    }
    return parsed.href;
  } catch { return ''; }
}
function cleanResearchSources(sources = []) {
  return (Array.isArray(sources) ? sources : []).map(source => {
    const url = cleanResearchUrl(typeof source === 'string' ? source : source?.url);
    const title = cleanResearchText(typeof source === 'string' ? '' : source?.title || source?.name);
    return {url, title};
  }).filter(source => source.url);
}
module.exports = {cleanResearchText, cleanResearchUrl, cleanResearchSources};
